export var SENTRY_RELEASE = "7358797f3b8213654543647504a02dace31c2390";
